export default __webpack_public_path__ + "static/media/works.e9fc8ea5.jpg";